import { render, staticRenderFns } from "./ModuleActions.vue?vue&type=template&id=b4873514"
import script from "./ModuleActions.vue?vue&type=script&lang=js"
export * from "./ModuleActions.vue?vue&type=script&lang=js"
import style0 from "./ModuleActions.vue?vue&type=style&index=0&id=b4873514&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports